module.exports = __webpack_public_path__ + "static/media/kennzeichnung_richtig.f9d29c5c.jpg";